import { cardSurface } from '@/components/atoms/Card';
import { Radio, RadioGroup } from '@/components/atoms/RadioGroup';

import styles from './ChoiceCards.module.scss';

export interface ChoiceCardOption {
    value: string;
    label: string;
    description?: string;
}

interface ChoiceCardsProps {
    options: ChoiceCardOption[];
    value: string;
    onChange: (value: string) => void;
    'aria-label': string;
}

/** One of a few choices, each a card with its consequence spelled out under the label. */
export default function ChoiceCards(props: ChoiceCardsProps) {
    const { options, value, onChange } = props;
    return (
        <RadioGroup
            className={styles.group}
            value={value}
            onValueChange={onChange}
            aria-label={props['aria-label']}>
            {options.map((option) => (
                <div
                    key={option.value}
                    {...cardSurface({
                        variant: 'outlined',
                        radius: 'sm',
                        padding: 'none',
                        interactive: true,
                        selected: option.value === value,
                    })}>
                    <Radio
                        value={option.value}
                        labelClassName={styles.choice}
                        label={
                            <span className={styles.text}>
                                <span className={styles.label}>{option.label}</span>
                                {option.description && (
                                    <span className={styles.description}>{option.description}</span>
                                )}
                            </span>
                        }
                    />
                </div>
            ))}
        </RadioGroup>
    );
}
